import React from 'react';

export function parseDescriptionLineBreaks(str='') {
  const lines = str.split(/\n/);
  return lines.map((line,i) => line ? <p key={i}>{line}</p> : <br key={i} />); 
}